import Icon from '../components/Icon.vue'

Icon.register({
  'digital-tachograph': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M608 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32h-576c-17.7 0-32-14.3-32-32v-256c0-17.7 14.3-32 32-32h576zM304 352v-8c0-4.4-3.6-8-8-8h-224c-4.4 0-8 3.6-8 8v8c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8zM72 288c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v16zM136 288c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v16zM200 288c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v16zM264 288c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v16zM304 224v-48c0-8.8-7.2-16-16-16h-208c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h208c8.8 0 16-7.2 16-16zM576 352v-8c0-4.4-3.6-8-8-8h-224c-4.4 0-8 3.6-8 8v8c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/digital-tachograph.js
// module id = 1270
// module chunks = 0